interface ErrorResponse {
  error?: {
    status?: number;
  };
}

export const is404Error = (error: unknown): boolean => {
  const err = error as ErrorResponse;
  return err?.error?.status === 404;
};
